import { RouteRecordRaw } from 'vue-router';

export const easyLanguageRoute: RouteRecordRaw = {
  name: 'EasyLanguage',
  path: '/easy-language',
  component: () => import('@/modules/EasyLanguage/EasyLanguage.vue'),
};
